import {
  routesAffectedByEditSelector,
  selectedOverlaySelector,
} from "../../reducers/matrixProfile/selectors";

import { Grid } from "@mui/material";
import { RouteLabel } from "../Layers/RouteLabelLayer/RouteLabel";
import { RouteVolumes } from "../Layers/RouteLabelLayer/RouteVolumes";
import { View } from "../View";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";

const useStyles = makeStyles({
  mainContainer: {
    display: "flex",
    overflowX: "auto",
  },
  container: {
    minHeight: "30px",
    background: "white",
    borderRadius: "4px",
    marginRight: "10px",
    flexWrap: "nowrap",
  },
  space: {
    width: "10px",
  },
  spacing: {
    padding: "2px",
    flexWrap: "nowrap",
  },
  routeLabelContainer: {
    height: "26px",
  },
});

export const RouteWithVolume = () => {
  const isVolumeOverlayOn = useSelector(selectedOverlaySelector);
  const styles = useStyles();
  const routesAffected = useSelector(routesAffectedByEditSelector);

  return (
    <View className={styles.mainContainer}>
      {routesAffected &&
        routesAffected.allAffected &&
        routesAffected.allAffected.map((route) => (
          <Grid key={route.routeCode} container className={styles.container}>
            <Grid
              item
              container
              xs={12}
              className={clsx(styles.spacing)}
              direction={"row"}
            >
              <RouteLabel routeCode={route.routeCode} />
              {isVolumeOverlayOn && (
                <RouteVolumes routeCode={route.routeCode} showAll={true} />
              )}
            </Grid>
          </Grid>
        ))}
    </View>
  );
};
